import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { TArrayCodec, array } from "../../../shared/src/codecs/types/array";
import { TFormCodec, form } from "../../../shared/src/codecs/types/form";
import { TRequiredCodec, required } from "../../../shared/src/codecs/types/required";
import { EmailTemplate, TEmailTemplateCodec } from "../EmailTemplate";
import { EmptyObject, TEmptyObjectCodec } from "../EmptyObject";

export const EmailTemplateForm: TFormCodec<
    TEmailTemplateCodec,
    TEmptyObjectCodec
> = form(
    EmailTemplate,
    EmptyObject,
);
export type TEmailTemplateFormCodec = typeof EmailTemplateForm;
export type TEmailTemplateForm = TTypeOfCodec<TEmailTemplateFormCodec>;

export const EmailTemplatesForm: TFormCodec<
    TEmptyObjectCodec,
    TRequiredCodec<{
        email_template_forms: TArrayCodec<TEmailTemplateFormCodec>,
    }>
> = form(
    EmptyObject,
    required({
        email_template_forms: array(EmailTemplateForm),
    }),
);
export type TEmailTemplatesFormCodec = typeof EmailTemplatesForm;
export type TEmailTemplatesForm = TTypeOfCodec<TEmailTemplatesFormCodec>;
